export const OrderStatus = {
  created: 1, // Pendiente (Por hacer)
  pending_payment: 2, // Pendiente de pago
  paid: 3,
  in_process: 4, // En preparación
  ready_for_delivery: 5, // Listo
  on_the_way: 6, // En camino
  at_delivery_point: 7, // En punto de entrega
  delivered: 8, // Entregado
  cancelled: 9, // Cancelado / Rechazado
  failled_paid: 10, // Pago fallido
} as const;

export type OrderStatusValue = (typeof OrderStatus)[keyof typeof OrderStatus];

export const OrderType = {
  pickup: 1, // Retiro / Para llevar
  delivery: 2, // Delivery
} as const;

export type OrderTypeValue = (typeof OrderType)[keyof typeof OrderType];
